import React from 'react';

import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import * as selectorsUser from '../../selector';
import { changeEmail } from '../thunk';

import TextFieldComp from '@/components/TextFieldComp';
import { uiSlice } from '@/domain/ui/redux';
import { Email } from '@/domain/user/service/entity/valueObjects/email';

type FormType = {
  email: string,
}

/**
 * プロパティ
 */
export type Props = {
  /** 開くか */
  isOpen: boolean,
  /** 閉じる */
  close: () => void,
}

const EditEmailDialog: React.FC<Props> = ({ isOpen, close }) => {
  const dispatch = useDispatch();
  const user = useSelector(selectorsUser.userSelector);
  const currentEmail = user?.attributes?.email || '';
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<FormType>({
    defaultValues: {
      email: '',
    },
  });
  const onSubmit = (input: FormType) => {
    if (input.email !== currentEmail) {
      dispatch(changeEmail(input.email));
      close();
    } else {
      dispatch(uiSlice.actions.setMessage({ key: 'warning', content: 'メールアドレスが現在のものと同じです' }));
    }
  };
  return (
    <Dialog open={isOpen}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle style={{ textAlign: 'center' }}>
          メールアドレス変更
        </DialogTitle>
        <DialogContent>
          <Typography variant="h6" gutterBottom>
            メールアドレス変更の手順
          </Typography>
          <Box component="ol" sx={{ pl: 2, mt: 0 }}>
            <Box component="li" sx={{ mb: 1 }}>
              <Typography component="span">新しいメールアドレスの入力</Typography>
              <Box sx={{ mt: 1 }}>
                <TextFieldComp
                  type={Email.type}
                  control={control}
                  rules={Email.validationRule}
                  name={Email.key}
                  label={Email.label}
                  placeholder={Email.placeholder}
                  errors={errors}
                />
              </Box>
            </Box>
            <Box component="li" sx={{ mb: 1 }}>
              <Typography component="span">
                {`アカウント名「${user?.name || ''}」でログイン`}
              </Typography>
              <Alert severity="warning" variant="outlined" sx={{ mt: 1 }}>
                変更後はアカウント名でのみログイン可能です。
              </Alert>
            </Box>
            <Box component="li">
              <Typography component="span">新しいメールアドレスに届いたコードを入力</Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button type="submit">
            変更する
          </Button>
          <Button onClick={() => close()}>閉じる</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default EditEmailDialog;
